/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React from 'react'
import { Column, Label, Button, Icon, Color } from 'trux'
import image from './no-tracer.svg'

export const YourTracerMissingContent = (props) => {
    let tn = props.tn ? props.tn : "10"
    return (
        <Column {...props} center>
            <svg width="76" height="95" viewBox="0 0 76 95" fill="none">
                <rect width="76" height="95" rx="15.3096" fill="#AFE7DE"/>
                <ellipse cx="37.9969" cy="57.0008" rx="24.7" ry="24.7" fill="white" fill-opacity="0.5"/>
                <text fill="#323333" fill-opacity="0.25" font-family="Montserrat" font-size="34" font-weight="bold" letter-spacing="-0.02em" text-anchor="middle" x="50%" y="69px">
                    <tspan>{tn}</tspan>
                </text>
                <text fill="#EC5366" font-family="Montserrat" font-size="67.8082" font-weight="bold" letter-spacing="-0.02em">
                    <tspan x="17.8106" y="71.8092">?</tspan>
                </text>
            </svg>
            <Label margin="4 0 6 0" type={Label.Type.Heading4} bold center>
                We couldn't identify you ☹️ 
            </Label>
            <Button
                marginBottom="8"
                href="https://traceup.com/soccer/help/sensorless-game-results"
                target="_blank"
                primary
                content={(
                    <>
                        Learn more
                        &nbsp;
                        <Icon type={Icon.Type.Leave} color={Color.TraceTint2} />
                    </>
                )}
            />
        </Column>
    )
}


